import { render } from "./content-pod.vue?vue&type=template&id=58c22bbe"
import script from "./content-pod.vue?vue&type=script&lang=js"
export * from "./content-pod.vue?vue&type=script&lang=js"

import "./content-pod.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__